import {RootDesc} from "@ui/descriptions/RootDesc";
import {useTranslation} from "react-i18next";
import ReactPaginate from "react-paginate";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const Pagination = (props) => {
  const {totalPages, data, toPage, page} = props;
  const {isMobile} = useSelector((state) => state.common.settings);
  const {t} = useTranslation();

  return (
    data?.length !== 0 && (
      <ReactPaginate
        containerClassName={styles.tableControls}
        pageLinkClassName={styles.pageLink}
        activeClassName={styles.activePage}
        previousClassName={styles.previousPage}
        nextClassName={styles.nextPage}
        disabledClassName={styles.disabledButton}
        renderOnZeroPageCount={null}
        pageRangeDisplayed={isMobile ? 1 : 3}
        marginPagesDisplayed={isMobile ? 1 : 3}
        pageCount={totalPages}
        forcePage={page === 0 ? page : page - 1}
        onPageChange={(item) => toPage(item?.selected)}
        breakLabel={"..."}
        nextLabel={
          <button>
            {!isMobile && (
              <RootDesc>
                <span>{t("table.next_page")}</span>
              </RootDesc>
            )}

            <i
              style={{
                borderTop: "5rem solid transparent",
                borderBottom: "5rem solid transparent",
                borderLeft: "9rem solid var(--blueLight)",
              }}
            />
          </button>
        }
        previousLabel={
          <button>
            <i
              style={{
                borderTop: "5rem solid transparent",
                borderBottom: "5rem solid transparent",
                borderRight: "9rem solid var(--blueLight)",
              }}
            />

            {!isMobile && (
              <RootDesc>
                <span>{t("table.prev_page")}</span>
              </RootDesc>
            )}
          </button>
        }
      />
    )
  );
};
